// extracted by mini-css-extract-plugin
module.exports = {"main":"Steps_main__3s6LW","body":"Steps_body__2uJx6"};